import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(maybeShowUnpaidAccountAnnouncement),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(addUserMsaAliasToLocalStorage),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(initializeReferAFriend),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(initializeUserLocation),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadCreditBalance),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(handleReservationStatusChanged),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadInitialApp),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(watchLoadInitialApp),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(watchReservationStatusChanged);

import * as logger from 'universal-logger';
import { fetchEntity, fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call, put, fork, select, takeEvery, all, spawn } from 'redux-saga/effects';
import { serialize as serializeCookie } from 'cookie';
import { UnpaidAccountBanner } from 'components/Banner/Banners/UnpaidAccountBanner';
import { memberStatus } from 'enums/memberStatus';
import { registerBanner } from 'features/Banners/BannerHost';
import { addAnnouncement } from 'features/Banners/Banners.reducer';
import { watchBannerSagas } from 'features/Banners/Banners.saga';
import { reservationStatusChanged } from 'features/Reservation/Reservation.saga';
import { setUserSelectedLocation } from 'redux/modules/locale';
import { userProfile, userUpcomingReservations, userPermissions, userCreditBalance, friendbuy } from 'redux/saga/entities/bound';
import { readLocalStorage, removeLocalStorage, writeLocalStorage } from 'redux/saga/helpers/local-storage';
import { isLoggedIn } from 'redux/saga/selectors';
import { friendbuyCode, FBUY_COOKIE_NAME } from 'redux/saga/selectors/friendbuy';
import { geodetectMsa } from 'redux/saga/helpers';
import { getNextCycleDate } from 'redux/saga/helpers/credit-cycle';
export var LOAD_INITIAL_APP = 'LOAD_INITIAL_APP';
export var loadInitialApp = function loadInitialApp() {
  return {
    type: LOAD_INITIAL_APP
  };
};
export function maybeShowUnpaidAccountAnnouncement(user) {
  return regeneratorRuntime.wrap(function maybeShowUnpaidAccountAnnouncement$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!memberStatus('UNPAID', user.membership.status)) {
            _context.next = 5;
            break;
          }

          _context.next = 3;
          return call(registerBanner, 'UnpaidAccountAnnouncement', UnpaidAccountBanner);

        case 3:
          _context.next = 5;
          return put(addAnnouncement('unpaid_account', 'UnpaidAccountAnnouncement'));

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function addUserMsaAliasToLocalStorage(client) {
  var msa;
  return regeneratorRuntime.wrap(function addUserMsaAliasToLocalStorage$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return call(geodetectMsa, client);

        case 3:
          msa = _context2.sent;

          if (!msa) {
            _context2.next = 7;
            break;
          }

          _context2.next = 7;
          return call(writeLocalStorage, 'userMsaAlias', msa.alias);

        case 7:
          _context2.next = 11;
          break;

        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);

        case 11:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 9]]);
}
export function initializeReferAFriend(client) {
  var referAFriendCode;
  return regeneratorRuntime.wrap(function initializeReferAFriend$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return select(friendbuyCode);

        case 2:
          referAFriendCode = _context3.sent;

          if (!referAFriendCode) {
            _context3.next = 12;
            break;
          }

          _context3.prev = 4;
          _context3.next = 7;
          return call(fetchEntityIfNeeded, friendbuy, [client, referAFriendCode]);

        case 7:
          if (__CLIENT__ || __TEST__) {
            document.cookie = serializeCookie(FBUY_COOKIE_NAME, referAFriendCode);
          }

          _context3.next = 12;
          break;

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](4);

        case 12:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[4, 10]]);
}
export function initializeUserLocation() {
  var _ref, lat, lon, expires;

  return regeneratorRuntime.wrap(function initializeUserLocation$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return call(readLocalStorage, 'userLocation', {});

        case 3:
          _ref = _context4.sent;
          lat = _ref.lat;
          lon = _ref.lon;
          expires = _ref.expires;

          if (!(expires <= Date.now())) {
            _context4.next = 12;
            break;
          }

          _context4.next = 10;
          return call(removeLocalStorage, 'userLocation');

        case 10:
          _context4.next = 15;
          break;

        case 12:
          if (!(lat && lon)) {
            _context4.next = 15;
            break;
          }

          _context4.next = 15;
          return put(setUserSelectedLocation(lat, lon));

        case 15:
          _context4.next = 19;
          break;

        case 17:
          _context4.prev = 17;
          _context4.t0 = _context4["catch"](0);

        case 19:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 17]]);
}
export function doLoadCreditBalance(client, userId) {
  var nextSubscriptionCycleDate, dataCalls;
  return regeneratorRuntime.wrap(function doLoadCreditBalance$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return call(getNextCycleDate, client, userId);

        case 3:
          nextSubscriptionCycleDate = _context5.sent;
          dataCalls = [call(fetchEntity, userCreditBalance, [client, userId])];

          if (nextSubscriptionCycleDate) {
            dataCalls.push(call(fetchEntity, userCreditBalance, [client, userId, {
              applicable_on: nextSubscriptionCycleDate
            }, true]));
          }

          _context5.next = 8;
          return all(dataCalls);

        case 8:
          _context5.next = 14;
          break;

        case 10:
          _context5.prev = 10;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 14;
          return call(logger.error, 'Could not load credit balance for user', _context5.t0);

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[0, 10]]);
}
export function handleReservationStatusChanged(client) {
  var isUserLoggedIn, user;
  return regeneratorRuntime.wrap(function handleReservationStatusChanged$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return select(isLoggedIn);

        case 2:
          isUserLoggedIn = _context6.sent;

          if (isUserLoggedIn) {
            _context6.next = 5;
            break;
          }

          return _context6.abrupt("return");

        case 5:
          _context6.next = 7;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 7:
          user = _context6.sent;
          _context6.next = 10;
          return all([call(doLoadCreditBalance, client, user.id), call(fetchEntity, userProfile, [client]), call(fetchEntity, userUpcomingReservations, [client, user.id])]);

        case 10:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
export function doLoadInitialApp(client) {
  var isUserLoggedIn, user;
  return regeneratorRuntime.wrap(function doLoadInitialApp$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return select(isLoggedIn);

        case 2:
          isUserLoggedIn = _context7.sent;
          _context7.next = 5;
          return all([spawn(watchBannerSagas), call(initializeReferAFriend, client), call(initializeUserLocation), call(addUserMsaAliasToLocalStorage, client)]);

        case 5:
          if (isUserLoggedIn) {
            _context7.next = 7;
            break;
          }

          return _context7.abrupt("return");

        case 7:
          _context7.next = 9;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 9:
          user = _context7.sent;
          _context7.next = 12;
          return all([call(doLoadCreditBalance, client, user.id), call(fetchEntityIfNeeded, userPermissions, [client, user.id]), call(fetchEntityIfNeeded, userUpcomingReservations, [client, user.id]), call(maybeShowUnpaidAccountAnnouncement, user)]);

        case 12:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
export function watchLoadInitialApp(client) {
  return regeneratorRuntime.wrap(function watchLoadInitialApp$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return fork(takeEvery, LOAD_INITIAL_APP, doLoadInitialApp, client);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}
export function watchReservationStatusChanged(client) {
  return regeneratorRuntime.wrap(function watchReservationStatusChanged$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return fork(takeEvery, reservationStatusChanged().type, handleReservationStatusChanged, client);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}